import React from 'react';
import { ZapIcon } from 'lucide-react';
import { Section } from './Shared';
import { Mandala } from './BioDecor';
const steps: string[] = ['Registras tu correo electrónico.', 'Recibes el acceso al material.', 'Descargas tus Tomos y Bonus.', 'Puedes utilizarlos desde celular, tablet o computadora.', 'También puedes imprimir las herramientas que quieras tener en consulta.'];
export function HowToReceive() {
  return <Section className="max-w-4xl" data-id="element-177" data-mp="1rb4xv2effi5m">
      <div className="paper-panel relative overflow-hidden rounded-3xl p-6 md:p-10" data-id="element-178" data-mp="1ra3jop246fjo">
        <Mandala className="pointer-events-none absolute -right-4 -top-4 h-24 w-24 text-brand-amber/25" data-id="element-179" data-mp="1mduyov18js4l" />
        <div className="relative" data-id="element-180" data-mp="1hc5o1ghxdgh1">
          <p className="mb-2 text-center text-sm font-bold uppercase tracking-[.18em] text-brand-goldDark" data-id="element-181" data-mp="1cf5prrrbhi0h">
            📥 Todo es 100% digital
          </p>
          <h2 className="text-center font-display text-2xl font-bold text-brand-blue md:text-4xl" data-id="element-182" data-mp="604sniqk2tsb">
            Cómo lo recibes
          </h2>
          <p className="mt-4 text-center text-sm text-brand-textLight md:text-base" data-id="element-183" data-mp="15saawse5i2th">
            Después de completar tu compra:
          </p>
          <ol className="mx-auto mt-7 grid max-w-2xl gap-3" data-id="element-184" data-mp="1aqliewgz418j">
            {steps.map((step, index) => <li key={step} className="flex items-start gap-4 rounded-xl border border-brand-blue/15 bg-white p-4" data-id="element-185" data-mp="vt1hq1r40s86" data-mpi={index}>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-blue text-xs font-bold text-brand-goldLight" data-id="element-186" data-mp="10r30elkmipj4">
                  {index + 1}
                </span>
                <span className="text-sm leading-relaxed text-brand-text md:text-base" data-id="element-187" data-mp="rtkdfbnf614l">{step}</span>
              </li>)}
          </ol>
          <p className="mt-7 flex items-center justify-center gap-2 text-center text-sm font-bold text-brand-greenMid md:text-base" data-id="element-188" data-mp="i2g00gde6obv">
            <ZapIcon className="h-4 w-4" data-id="element-189" data-mp="43pzeqrd66ir" />
            No hay envíos físicos ni esperas.
          </p>
        </div>
      </div>
    </Section>;
}